import { Grupo, ESTADOS, minutosDesde, duracion } from './mesas';
import { money } from '../../components/ui/estilos';

interface Props {
  secciones: { titulo: string; resumen: string; grupos: Grupo[] }[];
  selId?: string | null;
  resaltar: (g: Grupo) => string;
  atenuar: (g: Grupo) => boolean;
  onTocar: (g: Grupo) => void;
}

export default function CuadriculaSalon({ secciones, selId, resaltar, atenuar, onTocar }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {secciones.map(s => (
        <section key={s.titulo || 'unica'} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {s.titulo && (
            <h2 style={{ margin: 0, display: 'flex', alignItems: 'baseline', gap: 10, fontSize: 18, fontWeight: 700 }}>
              {s.titulo}<span style={{ fontSize: 15, fontWeight: 400, color: 'var(--muted)' }}>{s.resumen}</span>
            </h2>
          )}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 12 }}>
            {s.grupos.map(g => {
              const st = ESTADOS[g.estado], m = g.principal;
              const min = minutosDesde(m.ocupada_desde);
              const meta = g.estado === 'libre' ? `${m.capacidad} lugares`
                : g.estado === 'reservada' ? 'Reservada'
                : ['ocupada', 'por_cobrar', 'unida'].includes(g.estado) ? `${m.personas_actual || 0}/${m.capacidad} · ${duracion(min)}` : '';
              return (
                <button key={m.id} onClick={() => onTocar(g)} aria-pressed={selId === m.id}
                  aria-label={`Mesa ${g.etiqueta}, ${st.label}`}
                  style={{
                    position: 'relative', minHeight: 132, borderRadius: 14, background: st.bg, color: st.fg,
                    border: `2px ${st.borde} ${st.bd}`, outline: resaltar(g), outlineOffset: 3,
                    opacity: atenuar(g) ? 0.25 : 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                    gap: 4, padding: '14px 16px', cursor: 'pointer', textAlign: 'left',
                  }}>
                  <div style={{ display: 'flex', width: '100%', alignItems: 'baseline', justifyContent: 'space-between', gap: 8 }}>
                    <span style={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>{g.etiqueta}</span>
                    <span style={{ fontSize: 17, fontWeight: 700 }}>{g.total ? money(g.total) : ''}</span>
                  </div>
                  <span style={{ fontSize: 15, fontWeight: 700 }}>{st.label}</span>
                  <span style={{ fontSize: 15 }}>{meta}</span>
                  <span style={{ fontSize: 15 }}>{m.mesero || ''}</span>
                  {g.listos > 0 && (
                    <span style={{
                      position: 'absolute', top: -10, right: -8, padding: '4px 9px', borderRadius: 999,
                      background: 'var(--brand)', color: 'var(--on-brand)', fontSize: 13, fontWeight: 700, boxShadow: '0 0 0 3px var(--surface)',
                    }}>{g.listos} {g.listos === 1 ? 'listo' : 'listos'}</span>
                  )}
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
